import React from 'react';
import { UiModal } from 'src/components/UI/modal/UiModal';
import { useTHelper } from 'src/utils/i18n';
import { BaseSeparateModal } from 'src/models/modals';
import { CheckoutConfirmationResponseType, ParticipantTypeCode } from 'src/models/Checkout/Confirmation';
import { InfoIcon } from 'src/components/Icons/Info';
import styles from './styles.module.scss';

type Props = BaseSeparateModal & {
  model: CheckoutConfirmationResponseType['TeamMemberPaymentsSubSection'];
};

export const CreditingParticipantsInfoModal: React.FC<Props> = ({ model, onClose }: Props) => {
  const tHelper = useTHelper('checkout.confirmation.teamMemberPayments.modal');

  return (
    <UiModal
      header={
        <>
          <div className="d-flex">
            <div className={styles.iconBox}>
              <InfoIcon className={`tooltip-info-icon ${styles.icon}`} />
            </div>
            <div>
              <span>
                {tHelper('header', {
                  terminologyPlural:
                    model.ParticipantTypeID === ParticipantTypeCode.Member
                      ? model.TeamMemberTerminology.Plural || 'Participants'
                      : model.TeamTerminology.Plural || 'Teams',
                })}
              </span>
            </div>
          </div>
        </>
      }
      onlySuccessBtn
      onHide={onClose}
      successBtnText={tHelper('successBtnText')}
    >
      <p className="row-label">
        {tHelper('infoText', {
          terminologyPlural:
            model.ParticipantTypeID === ParticipantTypeCode.Member
              ? model.TeamMemberTerminology.Plural || 'Participants'
              : model.TeamTerminology.Plural || 'Teams',
          donationTerminology: model.DonationTerminology.Plural?.toLowerCase() || 'donations',
        })}
      </p>
      <ul className="bullet-list">
        {model.AvailableActivities.map((activity) => (
          <li key={activity}>{activity}</li>
        ))}
      </ul>
    </UiModal>
  );
};
